import React, { useState, useEffect } from "react";
import { Modal, Col, message } from "antd";
import { useForm, Controller } from "react-hook-form";
import Yup from "ValidationModels/localizedYup";
import DatePicker from "Components/date-picker-localized";
import FormLayout, { FormItem } from "Components/form";
import moment from "moment";
import { yupResolver } from "@hookform/resolvers";
import { createComponentStore } from "easy-peasy";
import { ContractStoreModel, ACTION_TYPES } from "store/models/contracts";
import { STATUS } from "Constants/contract";

const useContractStore = createComponentStore(ContractStoreModel);

export default function AbolishModal({ record, onCancel, onSubmit, ...props }) {
  const [store, actions] = useContractStore();

  const form = useForm({
    mode: "onSubmit",
    resolver: yupResolver(
      Yup.object({ dateOfRescission: Yup.date().required() })
    ),
    defaultValues: {
      dateOfRescission: moment(),
    },
  });

  useEffect(() => {
    if (store.process === ACTION_TYPES.UPDATED_STATU) {
      message.success("Sözleşme Feshedildi.");
      onSubmit();
    }
  }, [store.process]);

  const { control, handleSubmit, errors } = form;

  const formOnSubmit = (form) => {
    actions.updateStatu({ ...form, id: record.id, contractStatu: "ABOLISH" });
  };

  return (
    <Modal
      title="Feshet"
      visible={props.visible}
      onOk={handleSubmit(formOnSubmit)}
      okText="Feshet"
      cancelText="Geri"
      confirmLoading={store.process === ACTION_TYPES.UPDATING_STATU}
      onCancel={onCancel}
    >
      <FormLayout layout="horizontal">
        <Col xs={24}>
          <FormItem
            label="Feshi Tarihi"
            error={errors.dateOfRescission}
            required={true}
          >
            <Controller
              control={control}
              defaultValue={moment()}
              name="dateOfRescission"
              as={
                <DatePicker
                  format="DD.MM.YYYY"
                  style={{ width: "100%" }}
                  disabledDate={(current) =>
                    moment(current).isAfter(
                      moment(record.dateOfFinish).startOf("d")
                    )
                  }
                />
              }
            />
          </FormItem>
        </Col>
      </FormLayout>
    </Modal>
  );
}
